import { useCampaignAddonProducts } from '@campaign-services/hooks/useCampaignAddonProducts'
import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { CartSpecialOfferProductList } from '@cart-ui/CartSpecialOfferProductList/CartSpecialOfferProductList'
import { CartSpecialOfferProductListItem } from '@cart-ui/CartSpecialOfferProductListItem/CartSpecialOfferProductListItem'
import { type ProjectCode } from '@constants'
import { useDialog } from '@dni-hooks/useDialog'
import { formatPrice } from '@utils/formatCurrency'
import { CartCard } from '../CartCard/CartCard'
import { CartCardBody } from '../CartCardBody/CartCardBody'
import { CartCardHeader } from '../CartCardHeader/CartCardHeader'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'
import { Skeletons } from '../CartRegularGiveawayTips/Skeletons'
import { DIALOG_SELECT_PRODUCT_VARIATION, type DialogSelectProductVariationProps } from '../DialogSelectProductVariation/DialogSelectProductVariation'

export const CartAddonProducts = () => {
  const { projectCode, currency, campaignCode, campaignId } = useContextCampaignCart()
  const { allProjectProductMap, allProjectAddonProducts, isLoading: isLoadingAddonProducts } = useCampaignAddonProducts({ code: campaignCode, projectCode })
  const { destructuredData: campaignCouponCalculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)
  const { openDialog } = useDialog<DialogSelectProductVariationProps>(DIALOG_SELECT_PRODUCT_VARIATION)

  const handleActionClick = (parentProductId: number, productProjectCode?: ProjectCode) => () => {
    if (!productProjectCode) return
    openDialog({
      currency,
      parentProductId,
      productProjectCode,
    })
  }
  const { shipping_methods = [], total_after_discount = 0 } = campaignCouponCalculateResult || {}
  const maxAmount = shipping_methods[0]?.shipping_rules?.normal?.[0]?.applied_shipping_fee.max_amount ?? 0

  /**
   * applied max amount 的狀態還不應該免運，需要 +1 來算
   */
  const leftAmount = Math.max(0, maxAmount + 1 - total_after_discount)

  if (isLoadingAddonProducts) return <Skeletons title="加價購" />
  return allProjectAddonProducts.length
    ? (
      <>
        <CartCard>
          {/* todo: 還差多少免運 */}
          <CartCardHeader
            title="加價購"
            subTitle={leftAmount > 0 ? `${formatPrice(currency, leftAmount, '還差 $value免運')}` : ''}
          />
          <CartCardBody>
            <CartSpecialOfferProductList>
              {allProjectAddonProducts.map(group => (
                <CartSpecialOfferProductListItem
                  key={group.allProductId}
                  productImgSrc={allProjectProductMap[group.allProductId]?.thumbnail}
                  productTitle={allProjectProductMap[group.allProductId]?.title}
                  currency={currency}
                  salePrices={[...new Set(group.variations.map(variation => variation.sale_price))]}
                  onActionClick={handleActionClick(group.allProductId, group.variations[0]?.project_code)}
                />
              ))}
            </CartSpecialOfferProductList>
          </CartCardBody>
        </CartCard>
      </>
    )
    : null
}
